import apiService from './apiService'; // Import the reusable API service

const CUSTOMER_API_URL = '/customers'; // Base endpoint for customer-related operations

export const getTotalCustomers = async () => {
  const res = await apiService.get(`${CUSTOMER_API_URL}/count`);
  return res.data;
};

export const getContainerBalanceTotalCount = async () => {
  const res = await apiService.get(`${CUSTOMER_API_URL}/container-balances-summary`);
  return res.data;
};

// Fetch all customers with optional pagination
export const getAllCustomers = async (page = 1, limit = 10) => {
  try {
    const response = await apiService.get(CUSTOMER_API_URL, {
      params: { page, limit },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};


export const getCustomersByGroup = async (group_id) => {
  try {
    const response = await apiService.get(`${CUSTOMER_API_URL}/by-group`, {
      params: { group_id }, // Pass the group_id as a query parameter
    });
    return response.data; // Assuming the API response structure is { success: true, data: [...] }
  } catch (error) {
    console.error("Error fetching customers by group ID:", error.message);
    throw error;
  }
};


// Fetch a single customer by ID
export const getCustomerById = async (id) => {
  try {
    const response = await apiService.get(`${CUSTOMER_API_URL}/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Create a new customer
export const createCustomer = async (customerData) => {
  try {
    const response = await apiService.post(CUSTOMER_API_URL, customerData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Update an existing customer by ID
export const updateCustomer = async (id, customerData) => {
  try {
    const response = await apiService.put(`${CUSTOMER_API_URL}/${id}`, customerData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Delete a customer by ID
export const deleteCustomer = async (id) => {
  try {
    const response = await apiService.delete(`${CUSTOMER_API_URL}/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
